import React from 'react';

function ShoppingCart({fill = 'currentColor', secondaryfill, strokewidth = 1, width = '1em', height = '1em', ...props}) {
	secondaryfill = secondaryfill || fill;

	return (
		<svg height={height} width={width} {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<g fill={fill} strokeLinecap="butt" strokeLinejoin="miter">
		<circle cx="6" cy="21" fill={secondaryfill} r="1" stroke="none" strokeMiterlimit="10"/>
		<circle cx="20" cy="21" fill={secondaryfill} r="1" stroke="none" strokeMiterlimit="10"/>
		<circle cx="6" cy="21" fill={secondaryfill} r="1" stroke={secondaryfill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth}/>
		<circle cx="20" cy="21" fill={secondaryfill} r="1" stroke={secondaryfill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth}/>
		<path d="m4.821,6h17.179l-1.678,8.392c-.187.935-1.008,1.608-1.961,1.608H7.735c-.995,0-1.839-.732-1.98-1.717l-1.755-12.283H1" fill="none" stroke={fill} strokeLinecap="square" strokeMiterlimit="10" strokeWidth={strokewidth}/>
	</g>
</svg>
	);
};

export default ShoppingCart;